var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vector2i } from "js-vextensions";
import { BaseComponentPlus } from "react-vextensions";
import { GetMapObjectFinalPosition } from "Store/firebase/mapObjects/$mapObject";
import { Observer } from "vwebapp-framework";
import { ToolRender_ExtraInfo } from "./Tools/Tool";
import { currentMapTool } from "./MapScene";
let MapObjectUI_Overlay = class MapObjectUI_Overlay extends BaseComponentPlus({}, {}) {
    render() {
        let { obj, mapScene, finalPos } = this.props;
        finalPos = finalPos ?? GetMapObjectFinalPosition(obj);
        const tool = currentMapTool;
        const toolRender_extraInfo = new ToolRender_ExtraInfo();
        const toolRender_result = tool && tool.RenderForObject_Overlay(obj, toolRender_extraInfo);
        let innerUI;
        if (obj.label) {
            const pos_world = finalPos.Plus(obj.label.offset.As(Vector2i));
            const pos_canvas = mapScene.CanvasY0BotPosToCanvasPos(mapScene.WorldPosToCanvasY0BotPos(pos_world, true));
            innerUI = (React.createElement("div", { style: { position: "absolute", left: pos_canvas.x, top: pos_canvas.y } }, obj.label.text));
        }
        return (React.createElement("div", null,
            !toolRender_extraInfo.cancelNormalRender && innerUI,
            toolRender_result));
    }
};
MapObjectUI_Overlay = __decorate([
    Observer
], MapObjectUI_Overlay);
export { MapObjectUI_Overlay };
